/**
 * Banner 1068 — KUK dashboard-access band.
 *
 * A single band: artwork, a large icon, one bold line and a bordered CTA. No dynamic
 * rows, so no metadata.
 *
 * Every field maps to a column that already exists on `banner` — the variant adds no
 * schema of its own beyond widening `banner.variant`.
 */

export const BANNER_1068_CONSTANTS = {
  BANNER_FIELDS_CONFIG: [
    {
      fieldName: "background_image",
      label: "Artwork (768px and up)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      defaultValue: "",
    },
    {
      fieldName: "background_image_mobile",
      label: "Artwork (below 768px)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Optional — uses the desktop artwork if empty",
      defaultValue: "",
    },
    {
      fieldName: "image_alt",
      label: "Artwork alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      fieldName: "icon",
      label: "Icon above the heading",
      value: "gift",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload an icon, or type an icon name",
      defaultValue: "gift",
    },
    {
      fieldName: "icon_color",
      label: "Icon colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title",
      label: "Heading",
      value: "Access your exclusive dashboard!",
      valueType: "string",
      filedType: "TEXT_AREA",
      rows: 2,
      defaultValue: "Access your exclusive dashboard!",
    },
    {
      fieldName: "title_color",
      label: "Heading colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "apply_now_show",
      label: "Show the CTA",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
    {
      fieldName: "apply_now_text",
      label: "CTA text",
      value: "Refer & Earn",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "Refer & Earn",
    },
    {
      fieldName: "alt_icon",
      label: "CTA icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Optional — upload, or type an icon name",
      defaultValue: "",
    },
    {
      fieldName: "apply_now_is_cta",
      label: "CTA opens the lead form",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      description: "Off → link to the URL below instead.",
      defaultValue: true,
    },
    {
      fieldName: "apply_now_link",
      label: "CTA link (when it is not a lead form)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "/launchpad",
      defaultValue: "",
    },
    {
      fieldName: "apply_now_color",
      label: "CTA label colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "apply_now_border_color",
      label: "CTA border colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Banner status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [],
  METADATA_FIELDS_1: [],
};
